// extracted by mini-css-extract-plugin
module.exports = {"modal":"SocialPopUp_modal__LIWVr"};